import { RequestColumnName, SortDirection } from 'vrlcm-gui-types';

export namespace MigrationApiUri {
  const BASE_URL = '/lcm/vrcc/api/v1';
  const CONTENTS_BASE_URL = '/lcm/cms/api/v1';
  const ENDPOINTS_API_URL = `${CONTENTS_BASE_URL}/endpoints`;
  const CONTENTS_LIST_URL = 'content-list';
  const CONTENTS_CACHE_URL = 'content-cache';
  const VALIDATE_ENDPOINT_CREDENTIAL_API_URL = `${CONTENTS_BASE_URL}/validation`;
  const CONTENTS_REQUEST_API_URL = `${CONTENTS_BASE_URL}/requests`;

  export const VALIDATE_ENDPOINT_CREDENTIALS_API_URL = `${BASE_URL}/validate/content/credentials`;

  export const CREDENTIALS_EXISTENCE_API_URL = `${CONTENTS_BASE_URL}/contentcredential/existence`;

  export const ENDPOINT_CONTENT_LIST = (
    endpointId: string,
    contentType: string,
    force = false
  ) => {
    return `${ENDPOINTS_API_URL}/${endpointId}/${CONTENTS_LIST_URL}/${contentType}?force=${force}`;
  };

  export const CONTENT_CACHE_LIST = (requestOutParameter: string) => {
    return `${ENDPOINTS_API_URL}/${CONTENTS_CACHE_URL}/${requestOutParameter}`;
  };

  export const VALIDATE_ENDPOINT_CREDENTIAL = (contentType: string) => {
    return `${VALIDATE_ENDPOINT_CREDENTIAL_API_URL}?type=${contentType}`;
  };

  export const CONTENTS_REQUEST = (requestId: string) => {
    return `${CONTENTS_REQUEST_API_URL}/${requestId}`;
  };

  export const CREDENTIALS_API = `${CONTENTS_BASE_URL}/contentcredential`;

  export const SAAS_MIGRATION_DISCOVER = () => `${BASE_URL}/discover`;

  export const SAAS_MIGRATION_VALIDATE = () => `${BASE_URL}/migration/validate`;

  export const USER_MAPPING_VALIDATE = () =>
    `${BASE_URL}/migration/testconnection`;

  export const SAAS_MIGRATION_PRECHECK = () => `${BASE_URL}/precheck`;

  export const SAAS_MIGRATION_LIST = (
    currentPage: number,
    pageSize: number,
    sortBy?: RequestColumnName,
    sortByDirection?: SortDirection
  ) => {
    let url = `${BASE_URL}/migrationList?page=${currentPage}&limit=${pageSize}`;
    if (sortBy) {
      url += `&sortBy=${sortBy}`;
    }
    if (sortByDirection) {
      url += `&sortByDirection=${sortByDirection}`;
    }
    return url;
  };

  export const ADAPTER_LIST = (
    environmentId: string,
    sourceEndpointId: string
  ) =>
    `/lcm/vrcc/api/v1/migration/vrops/adapters?sourceEndpointId=${sourceEndpointId}&&environmentId=${environmentId}`;

  export const CONTENT_LIST = (productId: string) =>
    `/lcm/vrcc/api/v1/migration/${productId}/contents`;

  export const MIGRATION_OVERVIEW = (vmid: string) =>
  `/lcm/vrcc/api/v1/pipeline/status?vmid=${vmid}`;

  export const CREATE_SAVE_MIGRATION_REQUEST = () =>
    `${BASE_URL}/migration/request`;

  export const DELETE_MIGRATION_REQUEST = (vmid: string) =>
    `${BASE_URL}/migration/${vmid}`;

  export const SUBMIT_MIGRATION_REQUEST = () => `${BASE_URL}/migration`;

  export const GET_ADAPTER_LIST_REQUEST = (requestId: string) =>
    `/lcm/request/api/v3/requests/${requestId}`;

  export const VRNI_SAAS_ENDPOINTS = () =>
    `/lcm/cms/api/v1/endpoints?category=Network-Cloud&supportCapture=true&page=1&size=10000`;

  export const VRA_SAAS_ENDPOINTS = () =>
    `/lcm/cms/api/v1/endpoints?category=Automation-Cloud&supportCapture=true&page=1&size=10000`;

  export const VROPS_SAAS_ENDPOINTS = () =>
    `/lcm/cms/api/v1/endpoints?category=Operations-Cloud&supportCapture=true&page=1&size=10000`;

  export const NEW_SAAS_MIGRATION = () => `${BASE_URL}/migration`;

  export const SAAS_MIGRATION_REQUEST = (orgId: string, token: string) =>
    `${BASE_URL}/discover?orgId=${orgId}&token=${token}`;
}
